export const PARTY_CATEGORIES = [
  {
    name: 'Closing/Settlement agent',
    value: 'closing_agent',
  },
  { name: 'Closing/Settlement statement preparer', value: 'preparer' },
  {
    name: 'Deed/Instrument filer',
    value: 'recording_officer',
  },
  {
    name: 'Title insurance underwriter',
    value: 'title_insurer',
  },
  {
    name: 'Funds disperser',
    value: 'disbursing_agent',
  },
  { name: 'Title evaluation provider', value: 'evaluation' },
  {
    name: 'Deed/Instrument preparer',
    value: 'deed_preparer',
  },
];
